export default [
  {
    path: "department",
    name: "Đơn vị",
    // redirect: "/timekeeping/user-tk",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "EmployeeDepartments",
        name: "Gán nhân viên đơn vị",
        component: () =>
          import("@/views/screens/departments/EmployeeDepartments"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
